import { InfoRow } from '@/components/data-display'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover-v2'
import RenderIf from '@/components/ui/render-if'
import { Section } from '@/components/ui/section'
import { Separator } from '@/components/ui/separator'
import { Text } from '@/components/ui/text'
import { ICommissionSummary } from '@/data/referral'
import { useIsMd } from '@/hooks'
import { CommonApprovalDelegation, CommonArrowDropDown, CommonMoneyBag } from '@/icons'
import { cn } from '@/lib'
import { formatTokenAmount } from '@/utils'

import { useTranslation } from 'react-i18next'

import { TokenBalanceTable } from './TokenBalanceTable'

interface RewardTokenBalanceProps {
  commissionSummary?: ICommissionSummary
  isFetching?: boolean
  totalValue?: number
  availableValue?: number
}
export const RewardTokenBalance = ({
  commissionSummary,
  isFetching,
  totalValue,
  availableValue,
}: RewardTokenBalanceProps) => {
  const isMd = useIsMd()
  const isShowTokenBalance = commissionSummary?.availableUsdValue && commissionSummary?.availableUsdValue > 0
  const { t } = useTranslation()
  return (
    <Popover>
      <PopoverTrigger
        className={cn('flex items-center gap-2 group cursor-text', {
          'cursor-pointer': isShowTokenBalance,
        })}
      >
        <Text size={36} as='p' color='green' isLoading={isFetching}>
          {formatTokenAmount(totalValue || 0, 'USDT').slice(0, 5)} USDT
        </Text>
        <RenderIf condition={isShowTokenBalance}>
          <CommonArrowDropDown
            size={24}
            className='size-6 transition-transform duration-300 group-data-[state=open]:rotate-180'
          />
        </RenderIf>
      </PopoverTrigger>
      <RenderIf condition={isShowTokenBalance}>
        <PopoverContent
          align='start'
          className='px-2 md:px-6 py-2 md:py-3 space-y-3 max-w-sm md:max-w-[30.5625rem]'
          alignOffset={isMd ? 0 : -10}
        >
          <Section ring={false} className='bg-white-4'>
            <InfoRow icon={<CommonApprovalDelegation className='size-5' />} label={t('title.CLAIMED')}>
              <div className='flex items-center gap-2'>
                <Text>{formatTokenAmount((totalValue || 0) - (availableValue || 0), 'USDT')} USDT</Text>
                <img src='images/tokens/usdt-eth.svg' alt='usdt' className='size-5' />
              </div>
            </InfoRow>
          </Section>
          <Section ring={false} className='bg-white-4'>
            <InfoRow icon={<CommonMoneyBag className='size-5' />} label={t('title.EST_AVAILABLE_TO_CLAIM')}>
              <div className='flex items-center gap-2'>
                <Text>{formatTokenAmount(availableValue || 0, 'USDT')} USDT</Text>
                <img src='images/tokens/usdt-eth.svg' alt='usdt' className='size-5' />
              </div>
            </InfoRow>
            <Separator className='my-4' />
            <TokenBalanceTable commissionSummary={commissionSummary} />
          </Section>
        </PopoverContent>
      </RenderIf>
    </Popover>
  )
}
